module.exports = __webpack_public_path__ + "static/media/logo-circle.5d9bfa50.png";